// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1pcTb","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3wSNw"};